import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const VaultSortDropdownWrapper = styled.div`
    display: flex;
    width: 188px;
    padding: 16px 0px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;

    border-radius: 12px;
    border: 1px solid ${colors.gray3};
    background: #FFF;

    /* Card */
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.08), 0px 8px 16px 0px rgba(0, 0, 0, 0.04);

    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
`;

export const VaultSortDropdownTitle = styled.div`
    display: flex;
    padding: 0px 0px 8px 16px;
    align-items: center;
    gap: 10px;
    align-self: stretch;

    color: var(--Dark-Gray-3, #9097A3);
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;
`;

export const VaultSortDropdownItemsWrapper = styled.div`
    display: flex;
    padding: 0px 8px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
`;

export const VaultSortDropdownItem = styled.div`
    display: flex;
    height: 36px;
    padding: 6px 8px 6px 16px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;

    border-radius: 10px;

    color: var(--Dark-Gray-1, #1A1B1D);
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;

    &:hover {
        background: var(--Main-Colors-Light-Grey-1, #F7F8F9);
        cursor: pointer;
    }

    ${({ isActive }) => isActive && `
        background: var(--Main-Colors-Light-Grey-1, #F7F8F9);
    `}
`;

export const VaultDropdownItemCheckmarkIconWrapper = styled.div`
    display: flex;
    width: 24px;
    height: 24px;
    padding: 8px 5.039px 7.662px 7px;
    justify-content: center;
    align-items: center;
`;